<template>
  <div class="has-background-white is-border is-margin-top">
    <options-light-list :options="programOptions"></options-light-list>
  </div>
</template>

<script>

export default {
  name: 'ProgramOptions',
  components: {
    OptionsLightList: () => import('@/components/options/OptionsLightList')
  },
  props: {
    programOptions: {
      type: Array
    }
  },
  watch: {
    sourceProgramOptions (v) {
      this.updateSources({ options: v })
    }
  },
  methods: {
  }
}
</script>
